import { keymap } from 'prosemirror-keymap';
import { toggleMark } from 'prosemirror-commands';
import { undo, redo } from 'prosemirror-history';
import { activateLinkEditor } from './custom_commands';

const ORDER_REGEX = /Order-/;
/**
 * This treats strings that match the ORDER_REGEX as being a dual mapping, to
 * both Ctrl and Cmd, regardless of the platform. It produces a list of
 * overridden keybindings as well, which will include the `Mod-` version of each
 * ORDER_REGEX key, since there is nothing left for that binding to do.
 */
function convertOrder(map) {
   // Keybindings in ProseMirror format
   const bindings = {};

   Object.keys(map).forEach(key => {
      if (ORDER_REGEX.test(key)) {
         const ctrl = key.replace(ORDER_REGEX, 'Ctrl-');
         bindings[ctrl] = map[key];

         const cmd = key.replace(ORDER_REGEX, 'Cmd-');
         bindings[cmd] = map[key];

         const mod = key.replace(ORDER_REGEX, 'Mod-');
      } else {
         bindings[key] = map[key];
      }
   });

   return bindings;
}

export default function(schema, map = {}) {
   /** This section is based on
    * https://github.com/ProseMirror/prosemirror-example-setup/blob/master/src/keymap.js
    */
   // Add standard iFixit bindings (respecting what's actually available in the
   // schema)
   function bind(key, cmd) {
      map[key] = cmd;
   }

   let type;

   if (map['Mod-Enter']) {
      bind('Order-Enter', map['Mod-Enter']);
   }

   bind('Order-z', undo);
   bind('Order-y', redo);
   bind('Shift-Order-z', redo);

   if ((type = schema.marks.em)) {
      bind('Order-i', toggleMark(type));
   }

   if ((type = schema.marks.strong)) {
      bind('Order-b', toggleMark(type));
   }

   if ((type = schema.marks.underline)) {
      bind('Order-u', toggleMark(type));
   }

   if ((type = schema.marks.link)) {
      bind('Order-k', activateLinkEditor);
   }

   const bindings = convertOrder(map);
   return keymap(bindings);
}
